import { Badge, Box, Stack, Text } from '@mantine/core';

import { NavLink } from 'react-router-dom';

const SubTypeCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    return <Badge>{rowData.eventData?.sub_type}</Badge>;
};

const SubTypeColumn = () => ({
    accessorKey: 'eventData.sub_type',
    header: 'Sub-Type',
    size: 2,
    Cell: ({ cell }) => <SubTypeCell cell={cell} />,
});
export default SubTypeColumn;
